import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useSearchActions(data) {
    const {
        events: {
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = data;

    const {
        isInitialized
    } = useInitialization();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setAllValuesInitial, [...getObjectValues(initialValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentValuesChange() {
        if (isInitialized) {
            onCurrentValuesChange(currentValues);
        }
    }, [...getObjectValues(currentValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestValues);
        }
    }, [...getObjectValues(latestValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useSearchActions};
